export enum PageKey {
  HOME = 'home',
  LOGIN = 'login',
  USERS = 'users',
  USERS_CRUD = 'users_crud',
  OCCURRENCES = 'occurrences',
  SECTORS = 'sectors',
  ASSETS = 'assets',
  TASKS = 'tasks',
  EVENTS = 'events',
  PLACES = 'places',
  CHECKLISTS = 'checklists',
}
